import Constants from "../Constants";

export class AuthConstant {
  static AUTH_URL = Constants.AUTH_API_ENDPOINT + 'auth/';
}
